/* eslint-disable @typescript-eslint/camelcase */
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { setToLocalStorage } from '@lib/utils/local-storage'
import Spinner from '@components/common/spinner'
import { NextSeo } from 'next-seo'
import { CClient, staticFile } from '@common/utils'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

const competitionReferralLink = ({
  competitionTitle,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const router = useRouter()
  const { username, competition_slug, utm_medium = 'link' } = router.query

  useEffect(() => {
    setToLocalStorage('referrerUsername', String(username), () => {
      console.error('error saving referrerName to localstorage')
    })
    setToLocalStorage('referralCampaign', String(competition_slug), () => {
      console.error('error saving referralCampaign to localstorage')
    })

    competitionTitle = competitionTitle || (competition_slug as string)
    const referralCampaign = 'competition-referral'
    const redirectUrlPath = `/competitions/${competition_slug}/?utm_source=${competition_slug}&utm_medium=${utm_medium}&utm_campaign=${referralCampaign}&utm_content=${username}`
    router.push(redirectUrlPath)
  }, [])

  const prodReferralInviteLink = `/referral/competitions/${username}/${competition_slug}/`

  return (
    <>
      <NextSeo
        title="Join me on Codingal to participate in an exciting competition"
        description={`Join me on Codingal to participate in an exciting competition - ${competitionTitle}. Build apps/games/websites according to the theme or make code submissions to win the competition and get amazing prizes! Register now - ${prodReferralInviteLink}`}
        openGraph={{
          title:
            'Join me on Codingal to participate in an exciting competition',
          description: `Join me on Codingal to participate in an exciting competition - ${competitionTitle}. Build apps/games/websites according to the theme or make code submissions to win the competition and get amazing prizes! Register now - ${prodReferralInviteLink}`,
          type: 'website',
          url: prodReferralInviteLink,
          // eslint-disable-next-line @typescript-eslint/camelcase
          site_name: 'Codingal',
          images: [
            {
              url: staticFile('/images/referral/competition/og-image.png'),
              alt: `Codingal Referral Program`,
            },
          ],
        }}
      />
      <div className="min-h-screen w-full flex items-center justify-center">
        <Spinner classes="h-10 w-10 text-orange" />
      </div>
    </>
  )
}

type Data = {
  competitionTitle: string
}

export const getServerSideProps: GetServerSideProps<Data> = async (ctx) => {
  const { competition_slug } = ctx.query
  const response = await CClient(`/api/v1/competitions/${competition_slug}/`)
  if (!response.ok) return { props: {} as Data }
  const { title } = await response.json()
  return {
    props: {
      competitionTitle: title,
    },
  }
}

export default competitionReferralLink
